<template>
<div class="spackageVideoEdit form dialog-form">
    <el-dialog title="添加视频" :visible.sync="dialogFormVisible" width="600px">
        <el-form :model="item" label-width="0px" class="demo-ruleForm" label-position="left">
            <el-form-item label="">
                <el-tabs v-model="activeName">
                    <el-tab-pane label="视频" name="first">
                        <div class="result-list btn-operate-list">
                            <el-table ref="multipleTable" :data="videoData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
                                <el-table-column type="selection" width="55"></el-table-column>
                                <el-table-column prop="spackageName" label="专题名称" min-width="480px">
                                    <template slot-scope="scope">
                                        <div class="imageText">
                                            <img :src="scope.row.url" alt="">
                                            <div class="imageText-summary">
                                                <div>dgfhjfghjgfhjgfhjfjgfghfghfgfgh</div>
                                                <div class="error">{{item.price?item.price:'免费'}}</div>
                                            </div>
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="课程" name="second">
                    </el-tab-pane>
                    <el-tab-pane label="素材库" name="third">
                    </el-tab-pane>
                </el-tabs>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
export default {
    name: 'spackageVideoEdit',
    data() {
        return {
            item: {
                name: ''
            },
            videoData: [{url: 'https://img.bosszhipin.com/beijin/mcs/chatphoto/20190411/83dbaa9dc56d5f9fe2d82c307fa7983abeb58ae6f8deb6ddb017520ad68c070a_s.jpg?x-oss-process=image/resize,w_120,limit_0'}],
            activeName: 'first',
            dialogFormVisible: false
        }
    },
    mounted() {
    },
    methods: {
        handleSelectionChange() {

        },
        openDialog(row) {
            this.dialogFormVisible = true
        }
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.spackageVideoEdit {
    .el-table__row{
        height: auto !important;
    }
    .el-table__footer-wrapper, .el-table__header-wrapper{
        display: none;
    }
    .el-tabs__header{
        margin:0;
    }
    .el-tabs__content{
        height: 240px;
    }
    .customUpload{
        .el-form-item__content{
            @include flexBox(space-between)
        }
        .el-button{
            margin:0;
        }
        .el-input,.el-input__inner{
            height: 36px;
            line-height: 36px;
        }
    }
    img{
        width: 90px;
        height: 50px;
    }
}
</style>
